/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.getPublicCampaign.internal

import features.getPublicCampaign.models.PublicCampaignsResponseModel
import kangaroorewards.appsdk.core.io.IOResult
import kangaroorewards.appsdk.core.network.NetworkRequest
import kangaroorewards.appsdk.core.network.base.PathParameter
import kangaroorewards.appsdk.core.network.base.replaceInPath

internal class GetPublicCampaignRequest : NetworkRequest() {

    suspend fun getPublicCampaign(
        overrideHeaders: Map<String, String>? = null,
        campaignId: String
    ): IOResult<PublicCampaignsResponseModel> {
        return safeNetworkCall {
            get(
                endpoint = GetPublicCampaignEndpoint.replaceInPath(
                    PathParameter("campaignId", campaignId),
                ),
                serverHostId = 0,
                overrideHeaders = overrideHeaders
            )
        }
    }
}
